import React from 'react'

export default (props) => <div className="dashboard-card" style={{borderRadius: 5, padding: '1rem', flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{props.children}</div>